import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ElevationScroll from './ElevationScroll';
import {BackButton} from '../../../components';
import {makeStyles} from '@material-ui/core';

export interface HeaderProps {
    backButtonLabel: string;
    headerLabel: string;
}

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(6),
        borderBottom: `1px solid ${theme.palette.secondary.main}`,
        marginBottom: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            backgroundColor: '#0B0B0B',
            padding: theme.spacing(3, 4)
        }
    },
    toolbar: {
        justifyContent: 'space-between',
        '&:after': {
            content: '""',
            flex: 1
        }
    },
    backButton: {
        flex: 1
    },
    header: {
        fontWeight: 700,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            flex: '25%'
        }
    }
}));

const Header: React.FC<HeaderProps> = ({backButtonLabel, headerLabel}) => {
    const styles = useStyles();
    return (
        <ElevationScroll>
            <AppBar className={styles.root} color="default" position="sticky">
                <Toolbar className={styles.toolbar} disableGutters>
                    <div className={styles.backButton}>
                        <BackButton>{backButtonLabel}</BackButton>
                    </div>
                    <Typography className={styles.header} variant="h5">
                        {headerLabel}
                    </Typography>
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    );
};

export default Header;
